/**
 * Vague 18 — Bouton d'entrée vers la Cartographie 360°
 *
 * Composant atomique réutilisable pour ouvrir la vue x-ray
 * depuis n'importe quel module hôte (opportunité, entité, risque).
 */
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";

const SUBJECT_TYPES = ["opportunite", "entite", "risque"];

export default function Carto360Button({ subjectType, subjectId, label = "Cartographie 360°", compact = false, className = "", placement = "default" }) {
  if (!SUBJECT_TYPES.includes(subjectType) || !subjectId) return null;
  return (
    <Link
      to={`/app/cartographie/${subjectType}/${subjectId}`}
      className={`text-[10px] px-2 py-1 rounded border border-[#A78BFA]/40 bg-[#A78BFA]/10 text-[#A78BFA] hover:bg-[#A78BFA]/20 inline-flex items-center gap-1 transition ${className}`}
      data-testid={`carto360-open-${subjectType}-${placement === "default" ? subjectId : `${placement}-${subjectId}`}`}
      title="Ouvrir la cartographie 360° (vue x-ray + fantômes)"
    >
      <Layers className="w-3 h-3" />
      {compact ? "360°" : label}
    </Link>
  );
}
